import { RoutesMain } from "./RoutesMain";
import "react-phone-input-2/lib/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/style/style.css";

function App() {
    return <RoutesMain />;
}
export default App;
